import messages from '@intlify/unplugin-vue-i18n/messages'

const LOCALE_CODES = {
  FR: 'fr',
  NL: 'nl',
  EN: 'en'
} as const

export type Locale = (typeof LOCALE_CODES)[keyof typeof LOCALE_CODES]

export const LOCALE_FR: Locale = LOCALE_CODES.FR
export const LOCALE_NL: Locale = LOCALE_CODES.NL
export const LOCALE_EN: Locale = LOCALE_CODES.EN

export const SUPPORTED_LOCALES: Locale[] = [LOCALE_FR, LOCALE_NL, LOCALE_EN]

export const DEFAULT_LOCALE: Locale = LOCALE_FR

export const getLocaleFromURL = (): string | null => {
  const path = window.location.pathname // Get the path from the URL

  // Extract the locale from the path using a regular expression
  const regex = /^\/([^/]+)/ // Assumes the locale is the first part of the path
  const match = path.match(regex)

  // Return the extracted locale or null if not found
  return match && match[1] ? match[1] : null
}

export const allowedLocale = (localCandidate: string): boolean => SUPPORTED_LOCALES.includes(localCandidate as Locale)

export const setLocale = () => {
  // Get locale if user select one or get locale from user data or from navigator
  const localCandidate =
    getLocaleFromURL() ||
    localStorage.getItem('selected_locale') ||
    localStorage.getItem('user_locale') ||
    DEFAULT_LOCALE

  // Return localCandidate if it is supported or the default locale
  const locale = allowedLocale(localCandidate) ? localCandidate : DEFAULT_LOCALE
  localStorage.setItem('i18n-locale', locale)

  // Set the HTML lang attribute
  document.querySelector('html')?.setAttribute('lang', locale)

  return locale
}

export const setI18nOptions = {
  legacy: false,
  globalInjection: true,
  locale: setLocale(),
  fallbackLocale: DEFAULT_LOCALE,
  availableLocales: SUPPORTED_LOCALES,
  messages: messages,
  allowComposition: true
}
